import { i18n } from '../i18n';
import StringField from './fields/stringField';
import IdField from './fields/idField';

const label = (field) => i18n.t(`form.fields.${field}`);
const placeholder = (field) => i18n.t(`form.placeholder.${field}`);

export const fields = {
  id: new IdField('id', 'id'),
  name: new StringField('name', label('name'), placeholder('name'), {
    required: true
  }),
  code: new StringField('code', label('code'), placeholder('code'), {
    required: true
  }),
  trainingReason: new StringField('trainingReason', label('trainingReason')),
  action: new StringField('action', label('action')),
  createdAt: new StringField('createdAt', label('createdAt'))
};

export default {
  fields,
  placeholder
};
